import React, { useState } from 'react';
import axios from 'axios';
import { useEntidadeContext } from '../../EntidadeContext';
import { useAlertModal } from '../../AlertModalContext';

const OdontologiaConfigCard = () => {
  const { currentEntidade, setCurrentEntidade } = useEntidadeContext();
  const { showAlertModal } = useAlertModal();
  const [saving, setSaving] = useState(false);
  const enabled = !!currentEntidade?.odontologia_habilitada;
  const activeModules = currentEntidade?.modulos_ativos;
  const available = !Array.isArray(activeModules) || activeModules.includes('odontologia');

  const toggle = async () => {
    setSaving(true);
    try {
      const response = await axios.put('/api/odontologia/configuracao', { odontologia_habilitada: !enabled });
      setCurrentEntidade(response.data.entidade);
      showAlertModal('Módulo atualizado', !enabled ? 'Odontologia habilitada. A aba ficará disponível durante os atendimentos.' : 'Odontologia desabilitada. Os dados clínicos foram preservados.', 'success');
    } catch (error) {
      showAlertModal('Não foi possível atualizar', error.response?.data?.message || 'Tente novamente.', 'danger');
    } finally { setSaving(false); }
  };

  return <div style={{background:'#fff',border:'1px solid #dbeafe',borderRadius:14,padding:20,marginBottom:16,display:'flex',gap:18,justifyContent:'space-between',alignItems:'center'}}>
    <div><div style={{fontSize:14,fontWeight:800,color:'#0f172a'}}>Módulo Odontologia</div><p style={{margin:'4px 0 0',fontSize:12,color:'#64748b'}}>{available ? 'Adiciona odontograma, planos por dente, evolução e exames privados.' : 'Este módulo não está disponível para a empresa. Entre em contato para adicioná-lo.'}</p></div>
    <button type="button" onClick={toggle} disabled={saving || !available} style={{border:0,borderRadius:999,padding:'9px 16px',fontWeight:700,whiteSpace:'nowrap',color:'#fff',background:available?(enabled?'#0f766e':'#64748b'):'#94a3b8'}}>{!available?'Não disponível':saving?'Salvando...':enabled?'Ativado':'Ativar módulo'}</button>
  </div>;
};

export default OdontologiaConfigCard;
